export const MONSTERS = [
  {
    No: '000(00)',
    name: 'スライム',
    HP: '5',
    MP: '0',
    Ex: '1',
    G: '2',
    atk: '7',
    def: '5',
    speed: '2',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0.1,
      '3': 98.1,
      '4': 100,
      '5': 100,
      '6': 100,
      '7': 100,
      '8': 100,
      '9': 100,
      '10': 100,
      '11': 100,
      '12': 100,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '001(01)',
    name: 'おおナメクジ',
    HP: '8',
    MP: '0',
    Ex: '2',
    G: '3',
    atk: '9',
    def: '6',
    speed: '3',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 32.2,
      '4': 82.3,
      '5': 100,
      '6': 100,
      '7': 100,
      '8': 100,
      '9': 100,
      '10': 100,
      '11': 100,
      '12': 100,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '002(02)',
    name: 'アイアンアント',
    HP: '5',
    MP: '4',
    Ex: '2',
    G: '4',
    atk: '11',
    def: '13',
    speed: '4',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 36.4,
      '5': 79.2,
      '6': 99,
      '7': 100,
      '8': 100,
      '9': 100,
      '10': 100,
      '11': 100,
      '12': 100,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '003(03)',
    name: 'ドラキー',
    HP: '9',
    MP: '0',
    Ex: '3',
    G: '3',
    atk: '12',
    def: '8',
    speed: '5',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 14.3,
      '5': 43.1,
      '6': 78.6,
      '7': 93.6,
      '8': 100,
      '9': 100,
      '10': 100,
      '11': 100,
      '12': 100,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '004(04)',
    name: 'やまねずみ',
    HP: '10',
    MP: '0',
    Ex: '5',
    G: '5',
    atk: '14',
    def: '11',
    speed: '8',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 12,
      '7': 31.2,
      '8': 52.2,
      '9': 73.8,
      '10': 86.7,
      '11': 95,
      '12': 99.5,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '005(05)',
    name: 'ホイミスライム',
    HP: '25',
    MP: '20',
    Ex: '15',
    G: '5',
    atk: '15',
    def: '10',
    speed: '20',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 2.3,
      '13': 6.5,
      '14': 12.2,
      '15': 19.2,
      '16': 27.1,
      '17': 35.4,
      '18': 43.8,
      '19': 52.2,
      '20': 60.6,
      '21': 69.1,
      '22': 75.9,
      '23': 81.9,
      '24': 86.7,
      '25': 90.5,
      '26': 93.7,
      '27': 96.1,
      '28': 97.9,
      '29': 99.1,
      '30': 99.8,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '006(06)',
    name: 'ゆうれい',
    HP: '12',
    MP: '0',
    Ex: '6',
    G: '6',
    atk: '18',
    def: '10',
    speed: '8',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 12,
      '7': 31.1,
      '8': 52.2,
      '9': 73.9,
      '10': 86.6,
      '11': 95,
      '12': 99.5,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '007(07)',
    name: 'バブルスライム',
    HP: '13',
    MP: '0',
    Ex: '8',
    G: '4',
    atk: '16',
    def: '13',
    speed: '9',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 5.1,
      '7': 18.3,
      '8': 35.2,
      '9': 54.4,
      '10': 72.3,
      '11': 85.2,
      '12': 93.6,
      '13': 97.9,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '008(08)',
    name: 'ぐんたいアリ',
    HP: '12',
    MP: '0',
    Ex: '4',
    G: '2',
    atk: '19',
    def: '13',
    speed: '8',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 12,
      '7': 31,
      '8': 52.2,
      '9': 73.8,
      '10': 86.7,
      '11': 95,
      '12': 99.5,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '009(09)',
    name: 'まじゅつし',
    HP: '15',
    MP: '5',
    Ex: '10',
    G: '10',
    atk: '17',
    def: '11',
    speed: '11',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 3.5,
      '8': 12.9,
      '9': 26.2,
      '10': 40.7,
      '11': 56.1,
      '12': 71.6,
      '13': 82.4,
      '14': 90.3,
      '15': 95.7,
      '16': 98.5,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '010(0A)',
    name: 'おおねずみ',
    HP: '16',
    MP: '0',
    Ex: '7',
    G: '5',
    atk: '19',
    def: '11',
    speed: '15',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 2,
      '10': 7.4,
      '11': 15.5,
      '12': 25.6,
      '13': 36.3,
      '14': 47.6,
      '15': 58.9,
      '16': 69.9,
      '17': 78.8,
      '18': 85.8,
      '19': 90.8,
      '20': 94.9,
      '21': 97.6,
      '22': 99.2,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '011(0B)',
    name: 'キングコブラ',
    HP: '14',
    MP: '0',
    Ex: '9',
    G: '9',
    atk: '22',
    def: '10',
    speed: '11',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 3.5,
      '8': 12.9,
      '9': 26.2,
      '10': 40.7,
      '11': 56.1,
      '12': 71.7,
      '13': 82.3,
      '14': 90.3,
      '15': 95.7,
      '16': 98.5,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '012(0C)',
    name: 'ラリホーアント',
    HP: '14',
    MP: '6',
    Ex: '18',
    G: '8',
    atk: '18',
    def: '13',
    speed: '18',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 2.8,
      '12': 7.8,
      '13': 14.6,
      '14': 22.9,
      '15': 32.2,
      '16': 41.4,
      '17': 50.6,
      '18': 60,
      '19': 69.2,
      '20': 76.9,
      '21': 83.2,
      '22': 88.1,
      '23': 92.2,
      '24': 95.2,
      '25': 97.4,
      '26': 98.9,
      '27': 99.8,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '013(0D)',
    name: 'タホドラキー',
    HP: '12',
    MP: '4',
    Ex: '12',
    G: '10',
    atk: '14',
    def: '10',
    speed: '14',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 4.4,
      '10': 12.2,
      '11': 22.5,
      '12': 34.5,
      '13': 46.3,
      '14': 58.3,
      '15': 70.4,
      '16': 79.5,
      '17': 86.7,
      '18': 92.1,
      '19': 95.7,
      '20': 98.3,
      '21': 99.7,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '014(0E)',
    name: 'よろいムカデ',
    HP: '21',
    MP: '0',
    Ex: '14',
    G: '30',
    atk: '25',
    def: '40',
    speed: '13',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 2.6,
      '9': 9.7,
      '10': 19.8,
      '11': 31.8,
      '12': 45,
      '13': 57.6,
      '14': 70.5,
      '15': 80.6,
      '16': 87.7,
      '17': 93.2,
      '18': 96.8,
      '19': 98.9,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '015(0F)',
    name: 'しびれくらげ',
    HP: '20',
    MP: '0',
    Ex: '25',
    G: '50',
    atk: '28',
    def: '16',
    speed: '12',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 5.9,
      '9': 16,
      '10': 28.9,
      '11': 43,
      '12': 57.2,
      '13': 70.8,
      '14': 81.4,
      '15': 89.2,
      '16': 94.2,
      '17': 97.7,
      '18': 99.7,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '016(10)',
    name: 'リザードフライ',
    HP: '15',
    MP: '4',
    Ex: '27',
    G: '20',
    atk: '20',
    def: '10',
    speed: '16',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 3.5,
      '11': 9.7,
      '12': 17.9,
      '13': 27.8,
      '14': 38.3,
      '15': 48.9,
      '16': 59.3,
      '17': 69.6,
      '18': 78.2,
      '19': 84.7,
      '20': 90,
      '21': 93.9,
      '22': 96.7,
      '23': 98.7,
      '24': 99.8,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '017(11)',
    name: 'リビングデッド',
    HP: '60',
    MP: '3',
    Ex: '40',
    G: '25',
    atk: '25',
    def: '7',
    speed: '12',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 5.9,
      '9': 16,
      '10': 29,
      '11': 43,
      '12': 57.2,
      '13': 70.9,
      '14': 81.4,
      '15': 89.2,
      '16': 94.2,
      '17': 97.7,
      '18': 99.7,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '018(12)',
    name: 'スモーク',
    HP: '15',
    MP: '3',
    Ex: '18',
    G: '40',
    atk: '14',
    def: '40',
    speed: '15',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 2,
      '10': 7.5,
      '11': 15.6,
      '12': 25.6,
      '13': 36.5,
      '14': 47.7,
      '15': 59,
      '16': 70,
      '17': 78.8,
      '18': 85.8,
      '19': 90.9,
      '20': 94.9,
      '21': 97.6,
      '22': 99.1,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '019(13)',
    name: 'おばけねずみ',
    HP: '25',
    MP: '0',
    Ex: '23',
    G: '25',
    atk: '35',
    def: '12',
    speed: '25',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0.7,
      '15': 2.8,
      '16': 6.2,
      '17': 10.6,
      '18': 15.8,
      '19': 21.7,
      '20': 28.1,
      '21': 34.9,
      '22': 41.4,
      '23': 48.2,
      '24': 55,
      '25': 61.7,
      '26': 68.3,
      '27': 74.2,
      '28': 79.2,
      '29': 83.5,
      '30': 87.2,
      '31': 90.3,
      '32': 92.9,
      '33': 95.1,
      '34': 96.8,
      '35': 98.1,
      '36': 99,
      '37': 99.6,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '020(14)',
    name: 'マンドリル',
    HP: '35',
    MP: '0',
    Ex: '33',
    G: '45',
    atk: '40',
    def: '12',
    speed: '18',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 2.8,
      '12': 7.8,
      '13': 14.7,
      '14': 22.9,
      '15': 32.2,
      '16': 41.4,
      '17': 50.7,
      '18': 60.1,
      '19': 69.2,
      '20': 76.9,
      '21': 83.3,
      '22': 88.2,
      '23': 92.2,
      '24': 95.2,
      '25': 97.4,
      '26': 98.9,
      '27': 99.8,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '021(15)',
    name: 'マンイーター',
    HP: '32',
    MP: '0',
    Ex: '29',
    G: '31',
    atk: '32',
    def: '11',
    speed: '12',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 5.9,
      '9': 16,
      '10': 29,
      '11': 42.9,
      '12': 57.2,
      '13': 70.8,
      '14': 81.4,
      '15': 89.2,
      '16': 94.2,
      '17': 97.7,
      '18': 99.7,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '022(16)',
    name: 'かぶとムカデ',
    HP: '20',
    MP: '0',
    Ex: '33',
    G: '25',
    atk: '39',
    def: '110',
    speed: '13',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 2.6,
      '9': 9.6,
      '10': 19.9,
      '11': 31.8,
      '12': 45,
      '13': 57.5,
      '14': 70.6,
      '15': 80.6,
      '16': 87.8,
      '17': 93.1,
      '18': 96.9,
      '19': 98.9,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '023(17)',
    name: 'うみうし',
    HP: '32',
    MP: '0',
    Ex: '34',
    G: '80',
    atk: '38',
    def: '11',
    speed: '16',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 3.5,
      '11': 9.7,
      '12': 17.9,
      '13': 27.8,
      '14': 38.4,
      '15': 48.8,
      '16': 59.3,
      '17': 69.8,
      '18': 78.2,
      '19': 84.7,
      '20': 90,
      '21': 94,
      '22': 96.7,
      '23': 98.7,
      '24': 99.8,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '024(18)',
    name: 'メドーサボール',
    HP: '42',
    MP: '4',
    Ex: '36',
    G: '29',
    atk: '35',
    def: '13',
    speed: '22',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 1.9,
      '14': 5.4,
      '15': 10.3,
      '16': 16.3,
      '17': 23.1,
      '18': 30.8,
      '19': 38.2,
      '20': 45.9,
      '21': 53.4,
      '22': 61.1,
      '23': 68.7,
      '24': 75.1,
      '25': 80.6,
      '26': 85.3,
      '27': 89.1,
      '28': 92.3,
      '29': 94.8,
      '30': 96.8,
      '31': 98.2,
      '32': 99.2,
      '33': 99.8,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '025(19)',
    name: 'きとうし',
    HP: '40',
    MP: '10',
    Ex: '37',
    G: '30',
    atk: '36',
    def: '14',
    speed: '25',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0.7,
      '15': 2.9,
      '16': 6.2,
      '17': 10.6,
      '18': 15.8,
      '19': 21.8,
      '20': 28.1,
      '21': 34.9,
      '22': 41.5,
      '23': 48.2,
      '24': 54.9,
      '25': 61.6,
      '26': 68.4,
      '27': 74.2,
      '28': 79.2,
      '29': 83.6,
      '30': 87.2,
      '31': 90.3,
      '32': 93,
      '33': 95.1,
      '34': 96.8,
      '35': 98.1,
      '36': 99,
      '37': 99.6,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '026(1A)',
    name: 'どろにんぎょう',
    HP: '28',
    MP: '0',
    Ex: '32',
    G: '35',
    atk: '30',
    def: '9',
    speed: '22',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 1.9,
      '14': 5.4,
      '15': 10.3,
      '16': 16.3,
      '17': 23.2,
      '18': 30.8,
      '19': 38.2,
      '20': 45.9,
      '21': 53.4,
      '22': 61,
      '23': 68.6,
      '24': 75.2,
      '25': 80.6,
      '26': 85.3,
      '27': 89.1,
      '28': 92.3,
      '29': 94.8,
      '30': 96.8,
      '31': 98.2,
      '32': 99.3,
      '33': 99.8,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '027(1B)',
    name: 'バブーン',
    HP: '38',
    MP: '0',
    Ex: '40',
    G: '45',
    atk: '45',
    def: '12',
    speed: '18',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 2.8,
      '12': 7.9,
      '13': 14.7,
      '14': 22.9,
      '15': 32.2,
      '16': 41.3,
      '17': 50.6,
      '18': 60,
      '19': 69.1,
      '20': 76.9,
      '21': 83.3,
      '22': 88.2,
      '23': 92.2,
      '24': 95.2,
      '25': 97.4,
      '26': 98.9,
      '27': 99.8,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '028(1C)',
    name: 'しにがみ',
    HP: '40',
    MP: '0',
    Ex: '44',
    G: '50',
    atk: '51',
    def: '16',
    speed: '31',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0.4,
      '18': 1.9,
      '19': 4.2,
      '20': 7.2,
      '21': 10.9,
      '22': 15.1,
      '23': 19.7,
      '24': 24.8,
      '25': 30.1,
      '26': 35.5,
      '27': 40.8,
      '28': 46.2,
      '29': 51.7,
      '30': 57.1,
      '31': 62.4,
      '32': 67.9,
      '33': 72.7,
      '34': 76.9,
      '35': 80.8,
      '36': 84.1,
      '37': 87,
      '38': 89.7,
      '39': 91.9,
      '40': 93.8,
      '41': 95.5,
      '42': 96.7,
      '43': 97.8,
      '44': 98.8,
      '45': 99.3,
      '46': 99.7,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '029(1D)',
    name: 'グレムリン',
    HP: '60',
    MP: '4',
    Ex: '52',
    G: '47',
    atk: '57',
    def: '20',
    speed: '30',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 1,
      '18': 3,
      '19': 5.9,
      '20': 9.4,
      '21': 13.6,
      '22': 18.2,
      '23': 23.4,
      '24': 28.8,
      '25': 34.4,
      '26': 40.1,
      '27': 45.6,
      '28': 51.2,
      '29': 56.7,
      '30': 62.3,
      '31': 67.9,
      '32': 72.9,
      '33': 77.3,
      '34': 81.2,
      '35': 84.5,
      '36': 87.5,
      '37': 90.1,
      '38': 92.4,
      '39': 94.3,
      '40': 95.8,
      '41': 97.2,
      '42': 98.2,
      '43': 99,
      '44': 99.6,
      '45': 99.9,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '030(1E)',
    name: 'ポイズンキッス',
    HP: '46',
    MP: '0',
    Ex: '31',
    G: '25',
    atk: '45',
    def: '18',
    speed: '23',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0.8,
      '14': 3.3,
      '15': 7.3,
      '16': 12.3,
      '17': 18.3,
      '18': 25,
      '19': 32.1,
      '20': 39.4,
      '21': 46.8,
      '22': 53.9,
      '23': 61.3,
      '24': 68.7,
      '25': 74.8,
      '26': 80.2,
      '27': 84.6,
      '28': 88.4,
      '29': 91.6,
      '30': 94.1,
      '31': 96.1,
      '32': 97.8,
      '33': 98.9,
      '34': 99.6,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '031(1F)',
    name: 'ミイラおとこ',
    HP: '46',
    MP: '0',
    Ex: '44',
    G: '40',
    atk: '58',
    def: '2',
    speed: '1',
    speeds: {
      '0': 0,
      '1': 0.1,
      '2': 99.9,
      '3': 100,
      '4': 100,
      '5': 100,
      '6': 100,
      '7': 100,
      '8': 100,
      '9': 100,
      '10': 100,
      '11': 100,
      '12': 100,
      '13': 100,
      '14': 100,
      '15': 100,
      '16': 100,
      '17': 100,
      '18': 100,
      '19': 100,
      '20': 100,
      '21': 100,
      '22': 100,
      '23': 100,
      '24': 100,
      '25': 100,
      '26': 100,
      '27': 100,
      '28': 100,
      '29': 100,
      '30': 100,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '032(20)',
    name: 'ゴーゴンヘッド',
    HP: '26',
    MP: '4',
    Ex: '50',
    G: '62',
    atk: '30',
    def: '99',
    speed: '30',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 1,
      '18': 3.1,
      '19': 5.9,
      '20': 9.4,
      '21': 13.6,
      '22': 18.3,
      '23': 23.4,
      '24': 28.9,
      '25': 34.4,
      '26': 40,
      '27': 45.5,
      '28': 51.1,
      '29': 56.7,
      '30': 62.3,
      '31': 67.9,
      '32': 73,
      '33': 77.2,
      '34': 81.1,
      '35': 84.6,
      '36': 87.6,
      '37': 90.2,
      '38': 92.4,
      '39': 94.3,
      '40': 95.8,
      '41': 97.2,
      '42': 98.2,
      '43': 99,
      '44': 99.6,
      '45': 99.9,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '033(21)',
    name: 'サーベルウルフ',
    HP: '25',
    MP: '0',
    Ex: '45',
    G: '55',
    atk: '70',
    def: '20',
    speed: '42',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0.5,
      '24': 1.6,
      '25': 3.1,
      '26': 5,
      '27': 7.4,
      '28': 10.1,
      '29': 13.1,
      '30': 16.3,
      '31': 19.8,
      '32': 23.5,
      '33': 27.4,
      '34': 31.5,
      '35': 35.5,
      '36': 39.4,
      '37': 43.4,
      '38': 47.4,
      '39': 51.4,
      '40': 55.2,
      '41': 59.3,
      '42': 63.4,
      '43': 67.3,
      '44': 71,
      '45': 74.3,
      '46': 77.5,
      '47': 80.2,
      '48': 82.9,
      '49': 85.2,
      '50': 87.3,
      '51': 89.2,
      '52': 90.9,
      '53': 92.5,
      '54': 93.9,
      '55': 95,
      '56': 96.2,
      '57': 97.1,
      '58': 97.9,
      '59': 98.5,
      '60': 99,
      '61': 99.4,
      '62': 99.7,
      '63': 99.9,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '034(22)',
    name: 'ドラゴンフライ',
    HP: '40',
    MP: '0',
    Ex: '59',
    G: '43',
    atk: '51',
    def: '21',
    speed: '30',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 1,
      '18': 3.1,
      '19': 5.9,
      '20': 9.4,
      '21': 13.6,
      '22': 18.3,
      '23': 23.3,
      '24': 28.9,
      '25': 34.4,
      '26': 39.9,
      '27': 45.6,
      '28': 51.2,
      '29': 56.8,
      '30': 62.4,
      '31': 67.9,
      '32': 73,
      '33': 77.2,
      '34': 81.1,
      '35': 84.6,
      '36': 87.6,
      '37': 90.2,
      '38': 92.4,
      '39': 94.3,
      '40': 95.9,
      '41': 97.2,
      '42': 98.2,
      '43': 99,
      '44': 99.6,
      '45': 99.9,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '035(23)',
    name: 'じんめんじゅ',
    HP: '51',
    MP: '0',
    Ex: '50',
    G: '80',
    atk: '58',
    def: '19',
    speed: '30',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 1,
      '18': 3,
      '19': 5.9,
      '20': 9.4,
      '21': 13.6,
      '22': 18.2,
      '23': 23.4,
      '24': 28.9,
      '25': 34.4,
      '26': 39.9,
      '27': 45.6,
      '28': 51.1,
      '29': 56.8,
      '30': 62.4,
      '31': 67.9,
      '32': 72.9,
      '33': 77.3,
      '34': 81.1,
      '35': 84.6,
      '36': 87.5,
      '37': 90.2,
      '38': 92.4,
      '39': 94.3,
      '40': 95.8,
      '41': 97.2,
      '42': 98.2,
      '43': 99,
      '44': 99.6,
      '45': 99.9,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '036(24)',
    name: 'アンデッドマン',
    HP: '65',
    MP: '0',
    Ex: '45',
    G: '82',
    atk: '63',
    def: '17',
    speed: '33',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0.4,
      '19': 1.6,
      '20': 3.7,
      '21': 6.4,
      '22': 9.7,
      '23': 13.5,
      '24': 17.8,
      '25': 22.2,
      '26': 27.2,
      '27': 32.2,
      '28': 37.2,
      '29': 42.4,
      '30': 47.4,
      '31': 52.5,
      '32': 57.7,
      '33': 62.7,
      '34': 67.7,
      '35': 72.2,
      '36': 76.4,
      '37': 80,
      '38': 83.3,
      '39': 86.2,
      '40': 88.7,
      '41': 90.9,
      '42': 92.9,
      '43': 94.6,
      '44': 96,
      '45': 97.1,
      '46': 98.1,
      '47': 98.9,
      '48': 99.4,
      '49': 99.8,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '037(25)',
    name: 'バシリスク',
    HP: '38',
    MP: '0',
    Ex: '41',
    G: '58',
    atk: '75',
    def: '25',
    speed: '41',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0.2,
      '23': 1,
      '24': 2.4,
      '25': 4.2,
      '26': 6.5,
      '27': 9.1,
      '28': 12.1,
      '29': 15.3,
      '30': 18.9,
      '31': 22.6,
      '32': 26.6,
      '33': 30.6,
      '34': 34.6,
      '35': 38.7,
      '36': 42.8,
      '37': 46.9,
      '38': 51,
      '39': 55.1,
      '40': 59.1,
      '41': 63.3,
      '42': 67.3,
      '43': 71.1,
      '44': 74.6,
      '45': 77.7,
      '46': 80.4,
      '47': 83.1,
      '48': 85.5,
      '49': 87.6,
      '50': 89.6,
      '51': 91.3,
      '52': 92.9,
      '53': 94.3,
      '54': 95.5,
      '55': 96.5,
      '56': 97.4,
      '57': 98.1,
      '58': 98.7,
      '59': 99.2,
      '60': 99.6,
      '61': 99.8,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '038(26)',
    name: 'マドハンド',
    HP: '50',
    MP: '3',
    Ex: '29',
    G: '42',
    atk: '55',
    def: '16',
    speed: '39',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0.2,
      '22': 1.2,
      '23': 2.7,
      '24': 4.7,
      '25': 7.2,
      '26': 10,
      '27': 13.2,
      '28': 16.8,
      '29': 20.5,
      '30': 24.6,
      '31': 28.9,
      '32': 33.1,
      '33': 37.4,
      '34': 41.6,
      '35': 46,
      '36': 50.3,
      '37': 54.5,
      '38': 58.9,
      '39': 63.1,
      '40': 67.4,
      '41': 71.3,
      '42': 75,
      '43': 78.1,
      '44': 81.2,
      '45': 83.7,
      '46': 86.2,
      '47': 88.4,
      '48': 90.4,
      '49': 92.1,
      '50': 93.6,
      '51': 94.9,
      '52': 96.1,
      '53': 97.1,
      '54': 97.9,
      '55': 98.6,
      '56': 99.1,
      '57': 99.5,
      '58': 99.8,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '039(27)',
    name: 'オーク',
    HP: '60',
    MP: '0',
    Ex: '61',
    G: '50',
    atk: '75',
    def: '23',
    speed: '36',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0.7,
      '21': 2.2,
      '22': 4.2,
      '23': 6.8,
      '24': 9.8,
      '25': 13.2,
      '26': 17.2,
      '27': 21.2,
      '28': 25.7,
      '29': 30.4,
      '30': 35,
      '31': 39.6,
      '32': 44.4,
      '33': 49,
      '34': 53.6,
      '35': 58.2,
      '36': 62.9,
      '37': 67.6,
      '38': 71.8,
      '39': 75.6,
      '40': 79,
      '41': 82.2,
      '42': 85,
      '43': 87.3,
      '44': 89.6,
      '45': 91.6,
      '46': 93.3,
      '47': 94.8,
      '48': 96.1,
      '49': 97.1,
      '50': 98,
      '51': 98.7,
      '52': 99.3,
      '53': 99.7,
      '54': 99.9,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '040(28)',
    name: 'パペットマン',
    HP: '60',
    MP: '2',
    Ex: '52',
    G: '100',
    atk: '64',
    def: '24',
    speed: '70',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0.2,
      '38': 0.6,
      '39': 1.1,
      '40': 1.9,
      '41': 2.8,
      '42': 3.9,
      '43': 5.1,
      '44': 6.5,
      '45': 8,
      '46': 9.6,
      '47': 11.3,
      '48': 13.2,
      '49': 15.1,
      '50': 17.1,
      '51': 19.3,
      '52': 21.5,
      '53': 23.7,
      '54': 26,
      '55': 28.4,
      '56': 30.9,
      '57': 33.2,
      '58': 35.6,
      '59': 38,
      '60': 40.4,
      '61': 42.8,
      '62': 45.2,
      '63': 47.6,
      '64': 50,
      '65': 52.4,
      '66': 54.8,
      '67': 57.1,
      '68': 59.5,
      '69': 61.9,
      '70': 64.3,
      '71': 66.6,
      '72': 68.9,
      '73': 71.2,
      '74': 73.1,
      '75': 75.1,
      '76': 77,
      '77': 78.8,
      '78': 80.4,
      '79': 81.9,
      '80': 83.4,
      '81': 84.8,
      '82': 86.2,
      '83': 87.4,
      '84': 88.6,
      '85': 89.7,
      '86': 90.7,
      '87': 91.7,
      '88': 92.6,
      '89': 93.4,
      '90': 94.2,
      '91': 94.9,
      '92': 95.6,
      '93': 96.2,
      '94': 96.8,
      '95': 97.3,
      '96': 97.7,
      '97': 98.2,
      '98': 98.5,
      '99': 98.9,
      '100': 99.1,
      '101': 99.4,
      '102': 99.6,
      '103': 99.8,
      '104': 99.9,
      '105': 99.9,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '041(29)',
    name: 'マミー',
    HP: '75',
    MP: '0',
    Ex: '62',
    G: '60',
    atk: '70',
    def: '26',
    speed: '32',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0.9,
      '19': 2.7,
      '20': 5.2,
      '21': 8.3,
      '22': 12.1,
      '23': 16.3,
      '24': 21,
      '25': 25.9,
      '26': 31.1,
      '27': 36.4,
      '28': 41.6,
      '29': 46.8,
      '30': 52.1,
      '31': 57.2,
      '32': 62.6,
      '33': 67.9,
      '34': 72.4,
      '35': 76.7,
      '36': 80.4,
      '37': 83.7,
      '38': 86.6,
      '39': 89.2,
      '40': 91.4,
      '41': 93.3,
      '42': 95,
      '43': 96.3,
      '44': 97.5,
      '45': 98.4,
      '46': 99.1,
      '47': 99.6,
      '48': 99.9,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '042(2A)',
    name: 'ウドラー',
    HP: '63',
    MP: '4',
    Ex: '67',
    G: '95',
    atk: '72',
    def: '27',
    speed: '38',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0.6,
      '22': 1.9,
      '23': 3.8,
      '24': 6.1,
      '25': 8.9,
      '26': 12,
      '27': 15.6,
      '28': 19.4,
      '29': 23.5,
      '30': 27.8,
      '31': 32.3,
      '32': 36.7,
      '33': 41,
      '34': 45.4,
      '35': 49.9,
      '36': 54.3,
      '37': 58.6,
      '38': 63,
      '39': 67.4,
      '40': 71.4,
      '41': 75.2,
      '42': 78.4,
      '43': 81.6,
      '44': 84.2,
      '45': 86.6,
      '46': 88.7,
      '47': 90.8,
      '48': 92.5,
      '49': 93.9,
      '50': 95.3,
      '51': 96.5,
      '52': 97.4,
      '53': 98.2,
      '54': 98.8,
      '55': 99.3,
      '56': 99.7,
      '57': 99.9,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '043(2B)',
    name: 'ガスト',
    HP: '50',
    MP: '5',
    Ex: '39',
    G: '62',
    atk: '60',
    def: '80',
    speed: '45',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0.2,
      '25': 0.9,
      '26': 2,
      '27': 3.6,
      '28': 5.5,
      '29': 7.7,
      '30': 10.2,
      '31': 13.1,
      '32': 16.1,
      '33': 19.3,
      '34': 22.7,
      '35': 26.3,
      '36': 30,
      '37': 33.7,
      '38': 37.4,
      '39': 41.2,
      '40': 44.9,
      '41': 48.6,
      '42': 52.4,
      '43': 56,
      '44': 59.8,
      '45': 63.5,
      '46': 67.2,
      '47': 70.7,
      '48': 73.8,
      '49': 76.7,
      '50': 79.5,
      '51': 81.9,
      '52': 84.2,
      '53': 86.3,
      '54': 88.2,
      '55': 89.8,
      '56': 91.5,
      '57': 92.8,
      '58': 94.1,
      '59': 95.2,
      '60': 96.2,
      '61': 97.1,
      '62': 97.8,
      '63': 98.4,
      '64': 98.9,
      '65': 99.3,
      '66': 99.6,
      '67': 99.8,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '044(2C)',
    name: 'くさったしたい',
    HP: '90',
    MP: '0',
    Ex: '61',
    G: '51',
    atk: '51',
    def: '2',
    speed: '20',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 2.3,
      '13': 6.5,
      '14': 12.2,
      '15': 19.2,
      '16': 27.1,
      '17': 35.5,
      '18': 43.9,
      '19': 52.1,
      '20': 60.6,
      '21': 68.9,
      '22': 76,
      '23': 81.8,
      '24': 86.7,
      '25': 90.5,
      '26': 93.7,
      '27': 96.1,
      '28': 97.8,
      '29': 99.1,
      '30': 99.8,
      '31': 100,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '045(2D)',
    name: 'ホークマン',
    HP: '60',
    MP: '6',
    Ex: '64',
    G: '45',
    atk: '75',
    def: '27',
    speed: '41',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0.2,
      '23': 1.1,
      '24': 2.4,
      '25': 4.3,
      '26': 6.5,
      '27': 9.1,
      '28': 12.1,
      '29': 15.3,
      '30': 18.9,
      '31': 22.6,
      '32': 26.6,
      '33': 30.6,
      '34': 34.6,
      '35': 38.8,
      '36': 42.9,
      '37': 46.9,
      '38': 51,
      '39': 55.1,
      '40': 59.1,
      '41': 63.3,
      '42': 67.4,
      '43': 71.1,
      '44': 74.5,
      '45': 77.6,
      '46': 80.5,
      '47': 83.2,
      '48': 85.5,
      '49': 87.7,
      '50': 89.6,
      '51': 91.3,
      '52': 92.8,
      '53': 94.2,
      '54': 95.4,
      '55': 96.5,
      '56': 97.4,
      '57': 98.1,
      '58': 98.7,
      '59': 99.2,
      '60': 99.6,
      '61': 99.8,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '046(2E)',
    name: 'ようじゅつし',
    HP: '55',
    MP: '20',
    Ex: '72',
    G: '110',
    atk: '61',
    def: '28',
    speed: '43',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0.2,
      '24': 1,
      '25': 2.2,
      '26': 3.9,
      '27': 5.9,
      '28': 8.3,
      '29': 11.1,
      '30': 14.2,
      '31': 17.4,
      '32': 20.9,
      '33': 24.5,
      '34': 28.4,
      '35': 32.2,
      '36': 36.1,
      '37': 40,
      '38': 44.1,
      '39': 47.9,
      '40': 51.7,
      '41': 55.7,
      '42': 59.4,
      '43': 63.4,
      '44': 67.3,
      '45': 70.9,
      '46': 74.2,
      '47': 77.2,
      '48': 79.9,
      '49': 82.5,
      '50': 84.8,
      '51': 86.9,
      '52': 88.8,
      '53': 90.6,
      '54': 92.1,
      '55': 93.5,
      '56': 94.8,
      '57': 95.8,
      '58': 96.8,
      '59': 97.6,
      '60': 98.3,
      '61': 98.8,
      '62': 99.3,
      '63': 99.6,
      '64': 99.8,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '047(2F)',
    name: 'メタルスライム',
    HP: '5',
    MP: '30',
    Ex: '1015',
    G: '90',
    atk: '37',
    def: '255',
    speed: '100',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0.1,
      '53': 0.2,
      '54': 0.5,
      '55': 0.9,
      '56': 1.4,
      '57': 1.9,
      '58': 2.5,
      '59': 3.3,
      '60': 4.1,
      '61': 5,
      '62': 5.9,
      '63': 6.9,
      '64': 7.9,
      '65': 9.1,
      '66': 10.3,
      '67': 11.4,
      '68': 12.8,
      '69': 14.1,
      '70': 15.4,
      '71': 16.9,
      '72': 18.4,
      '73': 19.8,
      '74': 21.4,
      '75': 23,
      '76': 24.6,
      '77': 26.2,
      '78': 28,
      '79': 29.5,
      '80': 31.2,
      '81': 32.9,
      '82': 34.6,
      '83': 36.3,
      '84': 38,
      '85': 39.6,
      '86': 41.3,
      '87': 43.1,
      '88': 44.6,
      '89': 46.2,
      '90': 48,
      '91': 49.6,
      '92': 51.3,
      '93': 53.1,
      '94': 54.7,
      '95': 56.4,
      '96': 58,
      '97': 59.8,
      '98': 61.4,
      '99': 63.1,
      '100': 64.8,
      '101': 66.5,
      '102': 68,
      '103': 69.6,
      '104': 71.1,
      '105': 72.4,
      '106': 73.9,
      '107': 75.3,
      '108': 76.6,
      '109': 77.8,
      '110': 79.1,
      '111': 80.3,
      '112': 81.3,
      '113': 82.4,
      '114': 83.4,
      '115': 84.5,
      '116': 85.5,
      '117': 86.3,
      '118': 87.2,
      '119': 88,
      '120': 88.8,
      '121': 89.6,
      '122': 90.3,
      '123': 91,
      '124': 91.7,
      '125': 92.3,
      '126': 92.9,
      '127': 93.5,
      '128': 94.1,
      '129': 94.6,
      '130': 95.1,
      '131': 95.5,
      '132': 96,
      '133': 96.4,
      '134': 96.8,
      '135': 97.2,
      '136': 97.5,
      '137': 97.8,
      '138': 98.1,
      '139': 98.3,
      '140': 98.6,
      '141': 98.9,
      '142': 99.1,
      '143': 99.2,
      '144': 99.4,
      '145': 99.5,
      '146': 99.6,
      '147': 99.8,
      '148': 99.8,
      '149': 99.9
    }
  },
  {
    No: '048(30)',
    name: 'くびかりぞく',
    HP: '65',
    MP: '0',
    Ex: '77',
    G: '97',
    atk: '82',
    def: '25',
    speed: '57',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0.1,
      '31': 0.5,
      '32': 1.2,
      '33': 2.3,
      '34': 3.5,
      '35': 5,
      '36': 6.7,
      '37': 8.5,
      '38': 10.5,
      '39': 12.8,
      '40': 15.1,
      '41': 17.6,
      '42': 20.1,
      '43': 23,
      '44': 25.9,
      '45': 28.8,
      '46': 31.7,
      '47': 34.6,
      '48': 37.6,
      '49': 40.5,
      '50': 43.4,
      '51': 46.4,
      '52': 49.4,
      '53': 52.2,
      '54': 55.2,
      '55': 58.1,
      '56': 61,
      '57': 64,
      '58': 66.9,
      '59': 69.7,
      '60': 72.2,
      '61': 74.7,
      '62': 77,
      '63': 79.2,
      '64': 81.2,
      '65': 82.9,
      '66': 84.7,
      '67': 86.3,
      '68': 87.8,
      '69': 89.2,
      '70': 90.6,
      '71': 91.7,
      '72': 92.8,
      '73': 93.8,
      '74': 94.8,
      '75': 95.6,
      '76': 96.3,
      '77': 97,
      '78': 97.6,
      '79': 98.1,
      '80': 98.6,
      '81': 99,
      '82': 99.3,
      '83': 99.6,
      '84': 99.7,
      '85': 99.9,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '049(31)',
    name: 'あくまのめだま',
    HP: '50',
    MP: '0',
    Ex: '92',
    G: '88',
    atk: '67',
    def: '30',
    speed: '45',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0.2,
      '25': 0.9,
      '26': 2,
      '27': 3.5,
      '28': 5.5,
      '29': 7.7,
      '30': 10.2,
      '31': 13,
      '32': 16,
      '33': 19.2,
      '34': 22.6,
      '35': 26.3,
      '36': 30,
      '37': 33.7,
      '38': 37.4,
      '39': 41.2,
      '40': 44.8,
      '41': 48.7,
      '42': 52.3,
      '43': 56,
      '44': 59.8,
      '45': 63.4,
      '46': 67.2,
      '47': 70.7,
      '48': 73.8,
      '49': 76.7,
      '50': 79.4,
      '51': 81.9,
      '52': 84.2,
      '53': 86.2,
      '54': 88.1,
      '55': 89.9,
      '56': 91.5,
      '57': 92.8,
      '58': 94.1,
      '59': 95.2,
      '60': 96.2,
      '61': 97,
      '62': 97.8,
      '63': 98.4,
      '64': 98.9,
      '65': 99.3,
      '66': 99.6,
      '67': 99.8,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '050(32)',
    name: 'ヒババンゴ',
    HP: '60',
    MP: '3',
    Ex: '81',
    G: '83',
    atk: '74',
    def: '29',
    speed: '52',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0.3,
      '29': 1,
      '30': 2.1,
      '31': 3.4,
      '32': 5,
      '33': 6.8,
      '34': 8.9,
      '35': 11.3,
      '36': 13.7,
      '37': 16.3,
      '38': 19.1,
      '39': 22.1,
      '40': 25.2,
      '41': 28.4,
      '42': 31.6,
      '43': 34.8,
      '44': 38,
      '45': 41.2,
      '46': 44.4,
      '47': 47.7,
      '48': 51,
      '49': 54.1,
      '50': 57.3,
      '51': 60.6,
      '52': 63.8,
      '53': 67.1,
      '54': 70,
      '55': 72.9,
      '56': 75.5,
      '57': 77.9,
      '58': 80.2,
      '59': 82.3,
      '60': 84.2,
      '61': 86,
      '62': 87.7,
      '63': 89.3,
      '64': 90.7,
      '65': 91.9,
      '66': 93.1,
      '67': 94.2,
      '68': 95.2,
      '69': 96,
      '70': 96.8,
      '71': 97.4,
      '72': 98.1,
      '73': 98.6,
      '74': 99,
      '75': 99.3,
      '76': 99.6,
      '77': 99.8,
      '78': 99.9,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '051(33)',
    name: 'ブラッドハンド',
    HP: '60',
    MP: '0',
    Ex: '48',
    G: '30',
    atk: '65',
    def: '24',
    speed: '49',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0.1,
      '27': 0.7,
      '28': 1.7,
      '29': 3,
      '30': 4.7,
      '31': 6.6,
      '32': 8.8,
      '33': 11.2,
      '34': 13.8,
      '35': 16.6,
      '36': 19.6,
      '37': 22.8,
      '38': 26.1,
      '39': 29.5,
      '40': 32.9,
      '41': 36.4,
      '42': 39.8,
      '43': 43.2,
      '44': 46.6,
      '45': 50,
      '46': 53.4,
      '47': 56.9,
      '48': 60.3,
      '49': 63.7,
      '50': 67.1,
      '51': 70.3,
      '52': 73.3,
      '53': 76.1,
      '54': 78.5,
      '55': 80.8,
      '56': 83.1,
      '57': 85,
      '58': 87,
      '59': 88.6,
      '60': 90.1,
      '61': 91.5,
      '62': 92.8,
      '63': 94,
      '64': 95.1,
      '65': 96,
      '66': 96.8,
      '67': 97.5,
      '68': 98.1,
      '69': 98.6,
      '70': 99.1,
      '71': 99.4,
      '72': 99.7,
      '73': 99.9,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '052(34)',
    name: 'ゴールドオーク',
    HP: '100',
    MP: '6',
    Ex: '83',
    G: '255',
    atk: '80',
    def: '56',
    speed: '57',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0.1,
      '31': 0.5,
      '32': 1.2,
      '33': 2.2,
      '34': 3.5,
      '35': 5,
      '36': 6.6,
      '37': 8.5,
      '38': 10.5,
      '39': 12.7,
      '40': 15.1,
      '41': 17.5,
      '42': 20.3,
      '43': 22.9,
      '44': 25.7,
      '45': 28.7,
      '46': 31.7,
      '47': 34.6,
      '48': 37.6,
      '49': 40.5,
      '50': 43.4,
      '51': 46.4,
      '52': 49.2,
      '53': 52.2,
      '54': 55.1,
      '55': 58.1,
      '56': 61.1,
      '57': 64,
      '58': 66.9,
      '59': 69.7,
      '60': 72.3,
      '61': 74.7,
      '62': 77,
      '63': 79.1,
      '64': 81.2,
      '65': 83,
      '66': 84.7,
      '67': 86.4,
      '68': 87.8,
      '69': 89.2,
      '70': 90.6,
      '71': 91.8,
      '72': 92.9,
      '73': 93.8,
      '74': 94.7,
      '75': 95.6,
      '76': 96.3,
      '77': 97,
      '78': 97.6,
      '79': 98.1,
      '80': 98.6,
      '81': 99,
      '82': 99.3,
      '83': 99.6,
      '84': 99.7,
      '85': 99.9,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '053(35)',
    name: 'じごくのつかい',
    HP: '67',
    MP: '24',
    Ex: '107',
    G: '132',
    atk: '73',
    def: '28',
    speed: '75',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0.3,
      '41': 0.7,
      '42': 1.3,
      '43': 2,
      '44': 2.9,
      '45': 3.9,
      '46': 5.1,
      '47': 6.3,
      '48': 7.7,
      '49': 9.2,
      '50': 10.8,
      '51': 12.5,
      '52': 14.3,
      '53': 16.1,
      '54': 18.1,
      '55': 20.1,
      '56': 22.1,
      '57': 24.3,
      '58': 26.4,
      '59': 28.7,
      '60': 30.9,
      '61': 33.2,
      '62': 35.3,
      '63': 37.7,
      '64': 39.9,
      '65': 42,
      '66': 44.3,
      '67': 46.5,
      '68': 48.8,
      '69': 51,
      '70': 53.2,
      '71': 55.4,
      '72': 57.7,
      '73': 59.9,
      '74': 62.2,
      '75': 64.4,
      '76': 66.6,
      '77': 68.8,
      '78': 70.8,
      '79': 72.8,
      '80': 74.5,
      '81': 76.3,
      '82': 78,
      '83': 79.6,
      '84': 81,
      '85': 82.5,
      '86': 83.9,
      '87': 85.2,
      '88': 86.4,
      '89': 87.5,
      '90': 88.7,
      '91': 89.7,
      '92': 90.7,
      '93': 91.5,
      '94': 92.4,
      '95': 93.2,
      '96': 93.9,
      '97': 94.7,
      '98': 95.2,
      '99': 95.9,
      '100': 96.5,
      '101': 96.9,
      '102': 97.4,
      '103': 97.9,
      '104': 98.2,
      '105': 98.6,
      '106': 98.9,
      '107': 99.1,
      '108': 99.4,
      '109': 99.6,
      '110': 99.7,
      '111': 99.8,
      '112': 99.9,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '054(36)',
    name: 'グール',
    HP: '80',
    MP: '6',
    Ex: '91',
    G: '100',
    atk: '103',
    def: '19',
    speed: '21',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 1,
      '13': 4,
      '14': 8.6,
      '15': 14.5,
      '16': 21.3,
      '17': 29,
      '18': 36.9,
      '19': 44.8,
      '20': 52.9,
      '21': 60.8,
      '22': 68.7,
      '23': 75.6,
      '24': 81.2,
      '25': 85.9,
      '26': 89.8,
      '27': 92.9,
      '28': 95.4,
      '29': 97.3,
      '30': 98.7,
      '31': 99.5,
      '32': 100,
      '33': 100,
      '34': 100,
      '35': 100,
      '36': 100,
      '37': 100,
      '38': 100,
      '39': 100,
      '40': 100,
      '41': 100,
      '42': 100,
      '43': 100,
      '44': 100,
      '45': 100,
      '46': 100,
      '47': 100,
      '48': 100,
      '49': 100,
      '50': 100,
      '51': 100,
      '52': 100,
      '53': 100,
      '54': 100,
      '55': 100,
      '56': 100,
      '57': 100,
      '58': 100,
      '59': 100,
      '60': 100,
      '61': 100,
      '62': 100,
      '63': 100,
      '64': 100,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '055(37)',
    name: 'バピラス',
    HP: '57',
    MP: '0',
    Ex: '95',
    G: '83',
    atk: '75',
    def: '25',
    speed: '48',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0.4,
      '27': 1.2,
      '28': 2.4,
      '29': 4,
      '30': 5.8,
      '31': 7.9,
      '32': 10.3,
      '33': 12.9,
      '34': 15.6,
      '35': 18.8,
      '36': 21.9,
      '37': 25.3,
      '38': 28.7,
      '39': 32.1,
      '40': 35.6,
      '41': 39.2,
      '42': 42.7,
      '43': 46.2,
      '44': 49.7,
      '45': 53.2,
      '46': 56.7,
      '47': 60.1,
      '48': 63.7,
      '49': 67.1,
      '50': 70.4,
      '51': 73.4,
      '52': 76.1,
      '53': 78.8,
      '54': 81.2,
      '55': 83.4,
      '56': 85.4,
      '57': 87.2,
      '58': 88.9,
      '59': 90.5,
      '60': 91.8,
      '61': 93.2,
      '62': 94.3,
      '63': 95.3,
      '64': 96.3,
      '65': 97,
      '66': 97.7,
      '67': 98.3,
      '68': 98.8,
      '69': 99.2,
      '70': 99.5,
      '71': 99.8,
      '72': 99.9,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '056(38)',
    name: 'スカルナイト',
    HP: '72',
    MP: '4',
    Ex: '115',
    G: '80',
    atk: '83',
    def: '28',
    speed: '53',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0.1,
      '29': 0.6,
      '30': 1.5,
      '31': 2.6,
      '32': 4,
      '33': 5.7,
      '34': 7.6,
      '35': 9.7,
      '36': 12,
      '37': 14.5,
      '38': 17.1,
      '39': 20,
      '40': 22.8,
      '41': 25.9,
      '42': 29.1,
      '43': 32.2,
      '44': 35.4,
      '45': 38.6,
      '46': 41.7,
      '47': 44.9,
      '48': 48.1,
      '49': 51.2,
      '50': 54.4,
      '51': 57.5,
      '52': 60.7,
      '53': 63.8,
      '54': 67,
      '55': 70,
      '56': 72.6,
      '57': 75.3,
      '58': 77.6,
      '59': 79.9,
      '60': 82,
      '61': 83.9,
      '62': 85.8,
      '63': 87.4,
      '64': 89,
      '65': 90.4,
      '66': 91.6,
      '67': 92.8,
      '68': 93.9,
      '69': 94.8,
      '70': 95.8,
      '71': 96.5,
      '72': 97.2,
      '73': 97.8,
      '74': 98.4,
      '75': 98.8,
      '76': 99.2,
      '77': 99.5,
      '78': 99.7,
      '79': 99.9,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '057(39)',
    name: 'キラータイガー',
    HP: '80',
    MP: '0',
    Ex: '128',
    G: '55',
    atk: '95',
    def: '76',
    speed: '71',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0.3,
      '39': 0.8,
      '40': 1.4,
      '41': 2.3,
      '42': 3.2,
      '43': 4.4,
      '44': 5.7,
      '45': 7.1,
      '46': 8.6,
      '47': 10.2,
      '48': 11.9,
      '49': 13.8,
      '50': 15.7,
      '51': 17.7,
      '52': 19.9,
      '53': 22.1,
      '54': 24.2,
      '55': 26.5,
      '56': 29,
      '57': 31.3,
      '58': 33.6,
      '59': 35.9,
      '60': 38.3,
      '61': 40.7,
      '62': 43,
      '63': 45.5,
      '64': 47.8,
      '65': 50.2,
      '66': 52.6,
      '67': 54.8,
      '68': 57.3,
      '69': 59.5,
      '70': 62,
      '71': 64.4,
      '72': 66.7,
      '73': 68.9,
      '74': 71,
      '75': 73.1,
      '76': 75,
      '77': 76.9,
      '78': 78.5,
      '79': 80.2,
      '80': 81.8,
      '81': 83.3,
      '82': 84.6,
      '83': 86,
      '84': 87.2,
      '85': 88.3,
      '86': 89.4,
      '87': 90.4,
      '88': 91.4,
      '89': 92.3,
      '90': 93.2,
      '91': 94,
      '92': 94.7,
      '93': 95.4,
      '94': 96.1,
      '95': 96.6,
      '96': 97.1,
      '97': 97.6,
      '98': 98,
      '99': 98.4,
      '100': 98.8,
      '101': 99,
      '102': 99.3,
      '103': 99.5,
      '104': 99.7,
      '105': 99.8,
      '106': 99.9,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '058(3A)',
    name: 'メタルハンター',
    HP: '70',
    MP: '0',
    Ex: '125',
    G: '150',
    atk: '55',
    def: '95',
    speed: '61',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0.1,
      '33': 0.4,
      '34': 1.1,
      '35': 2,
      '36': 3,
      '37': 4.3,
      '38': 5.8,
      '39': 7.5,
      '40': 9.4,
      '41': 11.3,
      '42': 13.4,
      '43': 15.6,
      '44': 18,
      '45': 20.5,
      '46': 23,
      '47': 25.7,
      '48': 28.4,
      '49': 31.1,
      '50': 33.9,
      '51': 36.7,
      '52': 39.5,
      '53': 42.1,
      '54': 44.9,
      '55': 47.6,
      '56': 50.4,
      '57': 53.1,
      '58': 55.8,
      '59': 58.7,
      '60': 61.3,
      '61': 64.1,
      '62': 66.9,
      '63': 69.4,
      '64': 72,
      '65': 74.1,
      '66': 76.3,
      '67': 78.4,
      '68': 80.2,
      '69': 82,
      '70': 83.7,
      '71': 85.3,
      '72': 86.8,
      '73': 88.2,
      '74': 89.5,
      '75': 90.7,
      '76': 91.8,
      '77': 92.8,
      '78': 93.7,
      '79': 94.6,
      '80': 95.5,
      '81': 96.1,
      '82': 96.8,
      '83': 97.4,
      '84': 97.9,
      '85': 98.4,
      '86': 98.7,
      '87': 99.1,
      '88': 99.4,
      '89': 99.6,
      '90': 99.8,
      '91': 99.9,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '059(3B)',
    name: 'ベビル',
    HP: '69',
    MP: '30',
    Ex: '159',
    G: '121',
    atk: '80',
    def: '41',
    speed: '57',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0.1,
      '31': 0.5,
      '32': 1.2,
      '33': 2.2,
      '34': 3.5,
      '35': 5,
      '36': 6.6,
      '37': 8.4,
      '38': 10.5,
      '39': 12.8,
      '40': 15.1,
      '41': 17.5,
      '42': 20.2,
      '43': 22.9,
      '44': 25.9,
      '45': 28.7,
      '46': 31.7,
      '47': 34.6,
      '48': 37.5,
      '49': 40.5,
      '50': 43.4,
      '51': 46.3,
      '52': 49.3,
      '53': 52.2,
      '54': 55.2,
      '55': 58,
      '56': 61.1,
      '57': 64,
      '58': 66.9,
      '59': 69.7,
      '60': 72.3,
      '61': 74.6,
      '62': 76.9,
      '63': 79,
      '64': 81.1,
      '65': 83,
      '66': 84.7,
      '67': 86.3,
      '68': 87.8,
      '69': 89.3,
      '70': 90.5,
      '71': 91.7,
      '72': 92.8,
      '73': 93.8,
      '74': 94.8,
      '75': 95.6,
      '76': 96.3,
      '77': 97,
      '78': 97.6,
      '79': 98.1,
      '80': 98.6,
      '81': 99,
      '82': 99.3,
      '83': 99.5,
      '84': 99.7,
      '85': 99.9,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '060(3C)',
    name: 'ダークアイ',
    HP: '67',
    MP: '15',
    Ex: '118',
    G: '81',
    atk: '74',
    def: '22',
    speed: '55',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0.1,
      '30': 0.6,
      '31': 1.3,
      '32': 2.4,
      '33': 3.7,
      '34': 5.3,
      '35': 7.1,
      '36': 9.1,
      '37': 11.2,
      '38': 13.6,
      '39': 16.1,
      '40': 18.7,
      '41': 21.5,
      '42': 24.4,
      '43': 27.4,
      '44': 30.5,
      '45': 33.4,
      '46': 36.4,
      '47': 39.6,
      '48': 42.5,
      '49': 45.7,
      '50': 48.7,
      '51': 51.8,
      '52': 54.8,
      '53': 57.9,
      '54': 60.9,
      '55': 63.9,
      '56': 66.9,
      '57': 69.7,
      '58': 72.4,
      '59': 75,
      '60': 77.3,
      '61': 79.5,
      '62': 81.6,
      '63': 83.4,
      '64': 85.2,
      '65': 86.9,
      '66': 88.4,
      '67': 89.7,
      '68': 91.1,
      '69': 92.3,
      '70': 93.4,
      '71': 94.4,
      '72': 95.2,
      '73': 96.1,
      '74': 96.8,
      '75': 97.4,
      '76': 98,
      '77': 98.5,
      '78': 98.9,
      '79': 99.2,
      '80': 99.5,
      '81': 99.7,
      '82': 99.9,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '061(3D)',
    name: 'ガーゴイル',
    HP: '60',
    MP: '15',
    Ex: '107',
    G: '95',
    atk: '85',
    def: '51',
    speed: '64',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0.2,
      '35': 0.7,
      '36': 1.3,
      '37': 2.2,
      '38': 3.3,
      '39': 4.6,
      '40': 6.1,
      '41': 7.7,
      '42': 9.5,
      '43': 11.3,
      '44': 13.3,
      '45': 15.4,
      '46': 17.6,
      '47': 20,
      '48': 22.4,
      '49': 24.9,
      '50': 27.5,
      '51': 30.1,
      '52': 32.7,
      '53': 35.3,
      '54': 38,
      '55': 40.6,
      '56': 43.2,
      '57': 45.8,
      '58': 48.5,
      '59': 51.1,
      '60': 53.5,
      '61': 56.3,
      '62': 58.9,
      '63': 61.6,
      '64': 64.1,
      '65': 66.8,
      '66': 69.1,
      '67': 71.5,
      '68': 73.8,
      '69': 75.8,
      '70': 77.8,
      '71': 79.8,
      '72': 81.5,
      '73': 83.2,
      '74': 84.7,
      '75': 86.1,
      '76': 87.5,
      '77': 88.7,
      '78': 89.9,
      '79': 91,
      '80': 92.1,
      '81': 93.1,
      '82': 93.9,
      '83': 94.7,
      '84': 95.5,
      '85': 96.2,
      '86': 96.8,
      '87': 97.3,
      '88': 97.8,
      '89': 98.3,
      '90': 98.7,
      '91': 99,
      '92': 99.3,
      '93': 99.5,
      '94': 99.7,
      '95': 99.8,
      '96': 99.9,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '062(3E)',
    name: 'オークキング',
    HP: '110',
    MP: '15',
    Ex: '204',
    G: '181',
    atk: '99',
    def: '80',
    speed: '60',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0.2,
      '33': 0.8,
      '34': 1.5,
      '35': 2.5,
      '36': 3.8,
      '37': 5.2,
      '38': 6.9,
      '39': 8.6,
      '40': 10.5,
      '41': 12.7,
      '42': 15,
      '43': 17.3,
      '44': 19.8,
      '45': 22.4,
      '46': 25,
      '47': 27.8,
      '48': 30.6,
      '49': 33.4,
      '50': 36.2,
      '51': 39,
      '52': 41.8,
      '53': 44.6,
      '54': 47.3,
      '55': 50,
      '56': 53,
      '57': 55.6,
      '58': 58.3,
      '59': 61.3,
      '60': 64.1,
      '61': 66.8,
      '62': 69.5,
      '63': 71.9,
      '64': 74.3,
      '65': 76.5,
      '66': 78.6,
      '67': 80.5,
      '68': 82.3,
      '69': 84,
      '70': 85.6,
      '71': 87.1,
      '72': 88.4,
      '73': 89.7,
      '74': 90.9,
      '75': 92,
      '76': 93,
      '77': 94,
      '78': 94.9,
      '79': 95.7,
      '80': 96.4,
      '81': 97,
      '82': 97.6,
      '83': 98.1,
      '84': 98.5,
      '85': 98.9,
      '86': 99.2,
      '87': 99.5,
      '88': 99.7,
      '89': 99.8,
      '90': 99.9,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '063(3F)',
    name: 'メイジバピラス',
    HP: '82',
    MP: '25',
    Ex: '182',
    G: '103',
    atk: '77',
    def: '47',
    speed: '79',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0.2,
      '43': 0.6,
      '44': 1.2,
      '45': 1.8,
      '46': 2.7,
      '47': 3.5,
      '48': 4.6,
      '49': 5.8,
      '50': 7,
      '51': 8.4,
      '52': 9.9,
      '53': 11.4,
      '54': 13,
      '55': 14.7,
      '56': 16.5,
      '57': 18.4,
      '58': 20.3,
      '59': 22.2,
      '60': 24.2,
      '61': 26.4,
      '62': 28.4,
      '63': 30.5,
      '64': 32.6,
      '65': 34.8,
      '66': 36.9,
      '67': 39.1,
      '68': 41.1,
      '69': 43.3,
      '70': 45.3,
      '71': 47.6,
      '72': 49.7,
      '73': 51.7,
      '74': 54,
      '75': 56.1,
      '76': 58.2,
      '77': 60.2,
      '78': 62.4,
      '79': 64.5,
      '80': 66.6,
      '81': 68.6,
      '82': 70.5,
      '83': 72.4,
      '84': 74.1,
      '85': 75.9,
      '86': 77.4,
      '87': 79,
      '88': 80.4,
      '89': 81.9,
      '90': 83.1,
      '91': 84.5,
      '92': 85.7,
      '93': 86.7,
      '94': 87.9,
      '95': 88.9,
      '96': 89.8,
      '97': 90.8,
      '98': 91.6,
      '99': 92.4,
      '100': 93.2,
      '101': 93.9,
      '102': 94.6,
      '103': 95.2,
      '104': 95.8,
      '105': 96.3,
      '106': 96.8,
      '107': 97.2,
      '108': 97.6,
      '109': 98.1,
      '110': 98.4,
      '111': 98.7,
      '112': 99,
      '113': 99.2,
      '114': 99.4,
      '115': 99.6,
      '116': 99.7,
      '117': 99.8,
      '118': 99.9,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '064(40)',
    name: 'バーサーカー',
    HP: '78',
    MP: '0',
    Ex: '147',
    G: '123',
    atk: '109',
    def: '53',
    speed: '55',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0.1,
      '30': 0.6,
      '31': 1.3,
      '32': 2.4,
      '33': 3.7,
      '34': 5.3,
      '35': 7.1,
      '36': 9,
      '37': 11.2,
      '38': 13.6,
      '39': 16.1,
      '40': 18.7,
      '41': 21.5,
      '42': 24.3,
      '43': 27.4,
      '44': 30.4,
      '45': 33.5,
      '46': 36.5,
      '47': 39.6,
      '48': 42.6,
      '49': 45.6,
      '50': 48.7,
      '51': 51.7,
      '52': 54.8,
      '53': 57.8,
      '54': 60.8,
      '55': 64,
      '56': 67,
      '57': 69.8,
      '58': 72.5,
      '59': 75,
      '60': 77.4,
      '61': 79.5,
      '62': 81.6,
      '63': 83.4,
      '64': 85.3,
      '65': 86.8,
      '66': 88.4,
      '67': 89.8,
      '68': 91.2,
      '69': 92.3,
      '70': 93.4,
      '71': 94.3,
      '72': 95.2,
      '73': 96,
      '74': 96.8,
      '75': 97.4,
      '76': 98,
      '77': 98.5,
      '78': 98.9,
      '79': 99.2,
      '80': 99.5,
      '81': 99.7,
      '82': 99.9,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '065(41)',
    name: 'はぐれメタル',
    HP: '5',
    MP: '30',
    Ex: '10150',
    G: '255',
    atk: '75',
    def: '255',
    speed: '200',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0.1,
      '105': 0.2,
      '106': 0.3,
      '107': 0.4,
      '108': 0.6,
      '109': 0.8,
      '110': 1,
      '111': 1.3,
      '112': 1.5,
      '113': 1.8,
      '114': 2.1,
      '115': 2.4,
      '116': 2.8,
      '117': 3.2,
      '118': 3.5,
      '119': 3.9,
      '120': 4.3,
      '121': 4.8,
      '122': 5.2,
      '123': 5.7,
      '124': 6.1,
      '125': 6.7,
      '126': 7.2,
      '127': 7.7,
      '128': 8.3,
      '129': 8.8,
      '130': 9.4,
      '131': 10,
      '132': 10.6,
      '133': 11.3,
      '134': 11.8,
      '135': 12.5,
      '136': 13.1,
      '137': 13.8,
      '138': 14.4,
      '139': 15.2,
      '140': 15.9,
      '141': 16.6,
      '142': 17.3,
      '143': 18,
      '144': 18.8,
      '145': 19.6,
      '146': 20.2,
      '147': 21,
      '148': 21.8,
      '149': 22.7
    }
  },
  {
    No: '066(42)',
    name: 'ハーゴンのきし',
    HP: '77',
    MP: '25',
    Ex: '201',
    G: '135',
    atk: '115',
    def: '72',
    speed: '65',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0.1,
      '35': 0.4,
      '36': 0.9,
      '37': 1.7,
      '38': 2.7,
      '39': 3.9,
      '40': 5.2,
      '41': 6.7,
      '42': 8.3,
      '43': 10.1,
      '44': 12,
      '45': 14,
      '46': 16.1,
      '47': 18.3,
      '48': 20.7,
      '49': 23.1,
      '50': 25.6,
      '51': 28.1,
      '52': 30.7,
      '53': 33.2,
      '54': 35.9,
      '55': 38.4,
      '56': 41.1,
      '57': 43.6,
      '58': 46.1,
      '59': 48.7,
      '60': 51.3,
      '61': 53.9,
      '62': 56.5,
      '63': 59,
      '64': 61.7,
      '65': 64.3,
      '66': 66.7,
      '67': 69.3,
      '68': 71.5,
      '69': 73.6,
      '70': 75.7,
      '71': 77.7,
      '72': 79.5,
      '73': 81.2,
      '74': 82.9,
      '75': 84.4,
      '76': 85.8,
      '77': 87.2,
      '78': 88.5,
      '79': 89.7,
      '80': 90.8,
      '81': 91.9,
      '82': 92.8,
      '83': 93.7,
      '84': 94.5,
      '85': 95.3,
      '86': 95.9,
      '87': 96.6,
      '88': 97.2,
      '89': 97.7,
      '90': 98.1,
      '91': 98.5,
      '92': 98.9,
      '93': 99.2,
      '94': 99.4,
      '95': 99.6,
      '96': 99.8,
      '97': 99.9,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '067(43)',
    name: 'サイクロプス',
    HP: '115',
    MP: '0',
    Ex: '257',
    G: '99',
    atk: '121',
    def: '42',
    speed: '43',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0.2,
      '24': 1,
      '25': 2.2,
      '26': 3.9,
      '27': 5.9,
      '28': 8.4,
      '29': 11.1,
      '30': 14,
      '31': 17.4,
      '32': 20.8,
      '33': 24.5,
      '34': 28.3,
      '35': 32.2,
      '36': 36.1,
      '37': 40,
      '38': 43.9,
      '39': 47.9,
      '40': 51.8,
      '41': 55.7,
      '42': 59.6,
      '43': 63.4,
      '44': 67.3,
      '45': 70.8,
      '46': 74.2,
      '47': 77.2,
      '48': 80,
      '49': 82.4,
      '50': 84.8,
      '51': 86.9,
      '52': 88.8,
      '53': 90.6,
      '54': 92.1,
      '55': 93.6,
      '56': 94.8,
      '57': 95.8,
      '58': 96.8,
      '59': 97.6,
      '60': 98.3,
      '61': 98.8,
      '62': 99.3,
      '63': 99.6,
      '64': 99.8,
      '65': 100,
      '66': 100,
      '67': 100,
      '68': 100,
      '69': 100,
      '70': 100,
      '71': 100,
      '72': 100,
      '73': 100,
      '74': 100,
      '75': 100,
      '76': 100,
      '77': 100,
      '78': 100,
      '79': 100,
      '80': 100,
      '81': 100,
      '82': 100,
      '83': 100,
      '84': 100,
      '85': 100,
      '86': 100,
      '87': 100,
      '88': 100,
      '89': 100,
      '90': 100,
      '91': 100,
      '92': 100,
      '93': 100,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '068(44)',
    name: 'キラーマシン',
    HP: '90',
    MP: '0',
    Ex: '554',
    G: '120',
    atk: '115',
    def: '150',
    speed: '80',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0.1,
      '43': 0.4,
      '44': 0.8,
      '45': 1.5,
      '46': 2.2,
      '47': 3,
      '48': 4,
      '49': 5.1,
      '50': 6.3,
      '51': 7.6,
      '52': 8.9,
      '53': 10.4,
      '54': 12,
      '55': 13.6,
      '56': 15.2,
      '57': 17,
      '58': 18.9,
      '59': 20.8,
      '60': 22.7,
      '61': 24.7,
      '62': 26.9,
      '63': 29,
      '64': 31.1,
      '65': 33.2,
      '66': 35.1,
      '67': 37.3,
      '68': 39.3,
      '69': 41.3,
      '70': 43.5,
      '71': 45.6,
      '72': 47.8,
      '73': 49.8,
      '74': 51.9,
      '75': 54,
      '76': 56.1,
      '77': 58.2,
      '78': 60.3,
      '79': 62.4,
      '80': 64.4,
      '81': 66.5,
      '82': 68.6,
      '83': 70.4,
      '84': 72.4,
      '85': 74.1,
      '86': 75.8,
      '87': 77.4,
      '88': 78.8,
      '89': 80.3,
      '90': 81.7,
      '91': 83,
      '92': 84.2,
      '93': 85.5,
      '94': 86.6,
      '95': 87.6,
      '96': 88.7,
      '97': 89.7,
      '98': 90.6,
      '99': 91.4,
      '100': 92.2,
      '101': 93,
      '102': 93.7,
      '103': 94.4,
      '104': 95,
      '105': 95.6,
      '106': 96.1,
      '107': 96.6,
      '108': 97.1,
      '109': 97.5,
      '110': 97.9,
      '111': 98.3,
      '112': 98.6,
      '113': 98.8,
      '114': 99.1,
      '115': 99.3,
      '116': 99.5,
      '117': 99.7,
      '118': 99.8,
      '119': 99.9,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '069(45)',
    name: 'ドラゴン',
    HP: '90',
    MP: '0',
    Ex: '480',
    G: '147',
    atk: '120',
    def: '56',
    speed: '62',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0.2,
      '34': 0.7,
      '35': 1.4,
      '36': 2.4,
      '37': 3.6,
      '38': 4.9,
      '39': 6.5,
      '40': 8.2,
      '41': 9.9,
      '42': 12,
      '43': 14.1,
      '44': 16.4,
      '45': 18.7,
      '46': 21.1,
      '47': 23.7,
      '48': 26.3,
      '49': 29,
      '50': 31.8,
      '51': 34.5,
      '52': 37.1,
      '53': 39.7,
      '54': 42.5,
      '55': 45.2,
      '56': 48,
      '57': 50.7,
      '58': 53.3,
      '59': 56.1,
      '60': 58.7,
      '61': 61.4,
      '62': 64.1,
      '63': 66.8,
      '64': 69.4,
      '65': 71.7,
      '66': 74,
      '67': 76.2,
      '68': 78.1,
      '69': 80.1,
      '70': 81.9,
      '71': 83.5,
      '72': 85.1,
      '73': 86.6,
      '74': 88,
      '75': 89.2,
      '76': 90.4,
      '77': 91.6,
      '78': 92.6,
      '79': 93.5,
      '80': 94.4,
      '81': 95.2,
      '82': 95.9,
      '83': 96.6,
      '84': 97.1,
      '85': 97.7,
      '86': 98.2,
      '87': 98.6,
      '88': 98.9,
      '89': 99.2,
      '90': 99.5,
      '91': 99.7,
      '92': 99.8,
      '93': 99.9,
      '94': 100,
      '95': 100,
      '96': 100,
      '97': 100,
      '98': 100,
      '99': 100,
      '100': 100,
      '101': 100,
      '102': 100,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '070(46)',
    name: 'あくましんかん',
    HP: '180',
    MP: '44',
    Ex: '734',
    G: '170',
    atk: '110',
    def: '70',
    speed: '120',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0.2,
      '64': 0.4,
      '65': 0.6,
      '66': 1,
      '67': 1.3,
      '68': 1.8,
      '69': 2.3,
      '70': 2.9,
      '71': 3.5,
      '72': 4.2,
      '73': 4.9,
      '74': 5.6,
      '75': 6.5,
      '76': 7.4,
      '77': 8.3,
      '78': 9.2,
      '79': 10.2,
      '80': 11.2,
      '81': 12.2,
      '82': 13.2,
      '83': 14.5,
      '84': 15.6,
      '85': 16.8,
      '86': 18,
      '87': 19.2,
      '88': 20.5,
      '89': 21.8,
      '90': 23.1,
      '91': 24.5,
      '92': 25.9,
      '93': 27.3,
      '94': 28.6,
      '95': 30,
      '96': 31.4,
      '97': 32.8,
      '98': 34.3,
      '99': 35.6,
      '100': 37,
      '101': 38.5,
      '102': 39.8,
      '103': 41.2,
      '104': 42.5,
      '105': 44,
      '106': 45.4,
      '107': 46.7,
      '108': 48.2,
      '109': 49.6,
      '110': 51,
      '111': 52.4,
      '112': 53.8,
      '113': 55.2,
      '114': 56.5,
      '115': 57.9,
      '116': 59.3,
      '117': 60.7,
      '118': 62.1,
      '119': 63.5,
      '120': 64.9,
      '121': 66.3,
      '122': 67.7,
      '123': 68.9,
      '124': 70.3,
      '125': 71.5,
      '126': 72.7,
      '127': 73.8,
      '128': 75,
      '129': 76.1,
      '130': 77.1,
      '131': 78.1,
      '132': 79.2,
      '133': 80.1,
      '134': 81,
      '135': 82,
      '136': 82.8,
      '137': 83.7,
      '138': 84.5,
      '139': 85.3,
      '140': 86.1,
      '141': 86.9,
      '142': 87.6,
      '143': 88.3,
      '144': 88.9,
      '145': 89.5,
      '146': 90.1,
      '147': 90.8,
      '148': 91.3,
      '149': 91.9
    }
  },
  {
    No: '071(47)',
    name: 'フレイム',
    HP: '65',
    MP: '0',
    Ex: '315',
    G: '101',
    atk: '85',
    def: '54',
    speed: '68',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0.2,
      '37': 0.6,
      '38': 1.2,
      '39': 2,
      '40': 3,
      '41': 4.1,
      '42': 5.4,
      '43': 6.8,
      '44': 8.4,
      '45': 10.2,
      '46': 11.9,
      '47': 13.8,
      '48': 15.8,
      '49': 18,
      '50': 20.2,
      '51': 22.6,
      '52': 24.8,
      '53': 27.3,
      '54': 29.8,
      '55': 32.2,
      '56': 34.7,
      '57': 37.2,
      '58': 39.6,
      '59': 42.1,
      '60': 44.6,
      '61': 47,
      '62': 49.5,
      '63': 51.9,
      '64': 54.4,
      '65': 56.9,
      '66': 59.4,
      '67': 61.8,
      '68': 64.3,
      '69': 66.6,
      '70': 69.1,
      '71': 71.3,
      '72': 73.3,
      '73': 75.3,
      '74': 77.3,
      '75': 79.1,
      '76': 80.7,
      '77': 82.4,
      '78': 83.9,
      '79': 85.3,
      '80': 86.6,
      '81': 87.9,
      '82': 89,
      '83': 90.1,
      '84': 91.2,
      '85': 92.2,
      '86': 93,
      '87': 93.9,
      '88': 94.6,
      '89': 95.3,
      '90': 96,
      '91': 96.6,
      '92': 97.2,
      '93': 97.6,
      '94': 98.1,
      '95': 98.5,
      '96': 98.8,
      '97': 99.1,
      '98': 99.3,
      '99': 99.6,
      '100': 99.7,
      '101': 99.9,
      '102': 99.9,
      '103': 100,
      '104': 100,
      '105': 100,
      '106': 100,
      '107': 100,
      '108': 100,
      '109': 100,
      '110': 100,
      '111': 100,
      '112': 100,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '072(48)',
    name: 'シルバーデビル',
    HP: '89',
    MP: '30',
    Ex: '321',
    G: '96',
    atk: '102',
    def: '69',
    speed: '83',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0.2,
      '45': 0.6,
      '46': 1,
      '47': 1.7,
      '48': 2.4,
      '49': 3.2,
      '50': 4.2,
      '51': 5.3,
      '52': 6.4,
      '53': 7.6,
      '54': 9.1,
      '55': 10.4,
      '56': 11.9,
      '57': 13.5,
      '58': 15.1,
      '59': 16.9,
      '60': 18.6,
      '61': 20.4,
      '62': 22.3,
      '63': 24.2,
      '64': 26.2,
      '65': 28.2,
      '66': 30.2,
      '67': 32.3,
      '68': 34.3,
      '69': 36.4,
      '70': 38.3,
      '71': 40.4,
      '72': 42.4,
      '73': 44.3,
      '74': 46.4,
      '75': 48.4,
      '76': 50.4,
      '77': 52.4,
      '78': 54.4,
      '79': 56.5,
      '80': 58.5,
      '81': 60.5,
      '82': 62.4,
      '83': 64.5,
      '84': 66.5,
      '85': 68.5,
      '86': 70.3,
      '87': 72,
      '88': 73.8,
      '89': 75.5,
      '90': 76.9,
      '91': 78.4,
      '92': 79.9,
      '93': 81.3,
      '94': 82.5,
      '95': 83.8,
      '96': 85,
      '97': 86.1,
      '98': 87.1,
      '99': 88.1,
      '100': 89.1,
      '101': 90,
      '102': 90.8,
      '103': 91.7,
      '104': 92.4,
      '105': 93.2,
      '106': 93.8,
      '107': 94.5,
      '108': 95.1,
      '109': 95.7,
      '110': 96.2,
      '111': 96.6,
      '112': 97.1,
      '113': 97.5,
      '114': 97.9,
      '115': 98.2,
      '116': 98.5,
      '117': 98.8,
      '118': 99.1,
      '119': 99.3,
      '120': 99.5,
      '121': 99.6,
      '122': 99.7,
      '123': 99.9,
      '124': 99.9,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '073(49)',
    name: 'ブリザード',
    HP: '92',
    MP: '8',
    Ex: '412',
    G: '113',
    atk: '95',
    def: '73',
    speed: '85',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0.2,
      '46': 0.5,
      '47': 1,
      '48': 1.6,
      '49': 2.3,
      '50': 3.1,
      '51': 4,
      '52': 5,
      '53': 6.1,
      '54': 7.4,
      '55': 8.6,
      '56': 10,
      '57': 11.4,
      '58': 12.9,
      '59': 14.5,
      '60': 16.2,
      '61': 17.9,
      '62': 19.6,
      '63': 21.5,
      '64': 23.2,
      '65': 25.2,
      '66': 27.1,
      '67': 29.2,
      '68': 31.1,
      '69': 33,
      '70': 35.1,
      '71': 37,
      '72': 39,
      '73': 40.9,
      '74': 42.9,
      '75': 44.8,
      '76': 46.9,
      '77': 48.8,
      '78': 50.8,
      '79': 52.7,
      '80': 54.7,
      '81': 56.7,
      '82': 58.7,
      '83': 60.7,
      '84': 62.5,
      '85': 64.5,
      '86': 66.6,
      '87': 68.4,
      '88': 70.2,
      '89': 71.9,
      '90': 73.7,
      '91': 75.2,
      '92': 76.7,
      '93': 78.2,
      '94': 79.6,
      '95': 80.9,
      '96': 82.2,
      '97': 83.5,
      '98': 84.6,
      '99': 85.7,
      '100': 86.7,
      '101': 87.7,
      '102': 88.8,
      '103': 89.7,
      '104': 90.5,
      '105': 91.3,
      '106': 92.1,
      '107': 92.8,
      '108': 93.5,
      '109': 94.1,
      '110': 94.7,
      '111': 95.3,
      '112': 95.9,
      '113': 96.3,
      '114': 96.8,
      '115': 97.2,
      '116': 97.6,
      '117': 98,
      '118': 98.3,
      '119': 98.6,
      '120': 98.8,
      '121': 99.1,
      '122': 99.3,
      '123': 99.5,
      '124': 99.6,
      '125': 99.7,
      '126': 99.9,
      '127': 99.9,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '074(4A)',
    name: 'ギガンテス',
    HP: '175',
    MP: '0',
    Ex: '580',
    G: '165',
    atk: '150',
    def: '51',
    speed: '88',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0.1,
      '47': 0.3,
      '48': 0.7,
      '49': 1.2,
      '50': 1.8,
      '51': 2.5,
      '52': 3.3,
      '53': 4.2,
      '54': 5.2,
      '55': 6.3,
      '56': 7.5,
      '57': 8.8,
      '58': 10,
      '59': 11.4,
      '60': 12.9,
      '61': 14.4,
      '62': 16,
      '63': 17.6,
      '64': 19.3,
      '65': 21.1,
      '66': 22.8,
      '67': 24.6,
      '68': 26.5,
      '69': 28.4,
      '70': 30.3,
      '71': 32.3,
      '72': 34.2,
      '73': 36.1,
      '74': 38,
      '75': 39.8,
      '76': 41.8,
      '77': 43.6,
      '78': 45.6,
      '79': 47.5,
      '80': 49.4,
      '81': 51.3,
      '82': 53.1,
      '83': 55.1,
      '84': 57.1,
      '85': 58.9,
      '86': 60.7,
      '87': 62.7,
      '88': 64.7,
      '89': 66.5,
      '90': 68.3,
      '91': 70.1,
      '92': 71.7,
      '93': 73.4,
      '94': 75,
      '95': 76.4,
      '96': 77.8,
      '97': 79.2,
      '98': 80.6,
      '99': 81.8,
      '100': 82.9,
      '101': 84.1,
      '102': 85.2,
      '103': 86.2,
      '104': 87.2,
      '105': 88.2,
      '106': 89.1,
      '107': 89.9,
      '108': 90.8,
      '109': 91.6,
      '110': 92.3,
      '111': 92.9,
      '112': 93.7,
      '113': 94.3,
      '114': 94.8,
      '115': 95.4,
      '116': 95.8,
      '117': 96.3,
      '118': 96.8,
      '119': 97.2,
      '120': 97.6,
      '121': 97.9,
      '122': 98.2,
      '123': 98.5,
      '124': 98.8,
      '125': 99,
      '126': 99.2,
      '127': 99.4,
      '128': 99.6,
      '129': 99.7,
      '130': 99.8,
      '131': 99.9,
      '132': 99.9,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '075(4B)',
    name: 'デビルロード',
    HP: '138',
    MP: '35',
    Ex: '542',
    G: '100',
    atk: '118',
    def: '110',
    speed: '85',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0.2,
      '46': 0.5,
      '47': 1,
      '48': 1.6,
      '49': 2.3,
      '50': 3.1,
      '51': 4,
      '52': 5,
      '53': 6.2,
      '54': 7.4,
      '55': 8.6,
      '56': 10,
      '57': 11.4,
      '58': 12.9,
      '59': 14.4,
      '60': 16.2,
      '61': 17.8,
      '62': 19.6,
      '63': 21.4,
      '64': 23.2,
      '65': 25.2,
      '66': 27.1,
      '67': 29.1,
      '68': 31.1,
      '69': 33.1,
      '70': 35,
      '71': 37,
      '72': 39,
      '73': 40.9,
      '74': 43,
      '75': 44.9,
      '76': 46.9,
      '77': 48.7,
      '78': 50.7,
      '79': 52.8,
      '80': 54.7,
      '81': 56.7,
      '82': 58.6,
      '83': 60.7,
      '84': 62.6,
      '85': 64.5,
      '86': 66.5,
      '87': 68.3,
      '88': 70.3,
      '89': 71.9,
      '90': 73.7,
      '91': 75.2,
      '92': 76.7,
      '93': 78.2,
      '94': 79.6,
      '95': 80.9,
      '96': 82.3,
      '97': 83.4,
      '98': 84.6,
      '99': 85.7,
      '100': 86.8,
      '101': 87.8,
      '102': 88.7,
      '103': 89.6,
      '104': 90.5,
      '105': 91.3,
      '106': 92.1,
      '107': 92.8,
      '108': 93.4,
      '109': 94.1,
      '110': 94.8,
      '111': 95.3,
      '112': 95.8,
      '113': 96.3,
      '114': 96.8,
      '115': 97.2,
      '116': 97.6,
      '117': 98,
      '118': 98.3,
      '119': 98.6,
      '120': 98.9,
      '121': 99.1,
      '122': 99.3,
      '123': 99.5,
      '124': 99.6,
      '125': 99.7,
      '126': 99.8,
      '127': 99.9,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '076(4C)',
    name: 'アークデーモン',
    HP: '230',
    MP: '50',
    Ex: '1475',
    G: '235',
    atk: '140',
    def: '135',
    speed: '105',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0.1,
      '56': 0.3,
      '57': 0.6,
      '58': 1,
      '59': 1.5,
      '60': 2,
      '61': 2.7,
      '62': 3.4,
      '63': 4.1,
      '64': 5,
      '65': 5.8,
      '66': 6.7,
      '67': 7.8,
      '68': 8.8,
      '69': 10,
      '70': 11,
      '71': 12.3,
      '72': 13.6,
      '73': 14.8,
      '74': 16.2,
      '75': 17.5,
      '76': 19,
      '77': 20.4,
      '78': 21.8,
      '79': 23.4,
      '80': 24.9,
      '81': 26.5,
      '82': 28.1,
      '83': 29.7,
      '84': 31.4,
      '85': 33,
      '86': 34.5,
      '87': 36.1,
      '88': 37.7,
      '89': 39.4,
      '90': 40.8,
      '91': 42.5,
      '92': 44,
      '93': 45.8,
      '94': 47.3,
      '95': 48.9,
      '96': 50.5,
      '97': 52,
      '98': 53.6,
      '99': 55.1,
      '100': 56.8,
      '101': 58.4,
      '102': 60,
      '103': 61.6,
      '104': 63.2,
      '105': 64.8,
      '106': 66.4,
      '107': 67.9,
      '108': 69.4,
      '109': 70.9,
      '110': 72.2,
      '111': 73.6,
      '112': 74.8,
      '113': 76.1,
      '114': 77.3,
      '115': 78.4,
      '116': 79.6,
      '117': 80.8,
      '118': 81.7,
      '119': 82.8,
      '120': 83.8,
      '121': 84.7,
      '122': 85.5,
      '123': 86.4,
      '124': 87.3,
      '125': 88.1,
      '126': 88.9,
      '127': 89.6,
      '128': 90.3,
      '129': 90.9,
      '130': 91.6,
      '131': 92.3,
      '132': 92.8,
      '133': 93.3,
      '134': 93.9,
      '135': 94.4,
      '136': 94.8,
      '137': 95.3,
      '138': 95.8,
      '139': 96.2,
      '140': 96.5,
      '141': 96.9,
      '142': 97.2,
      '143': 97.6,
      '144': 97.9,
      '145': 98.1,
      '146': 98.4,
      '147': 98.6,
      '148': 98.8,
      '149': 99
    }
  },
  {
    No: '077(4D)',
    name: 'アトラス',
    HP: '250',
    MP: '0',
    Ex: '2500',
    G: '250',
    atk: '195',
    def: '160',
    speed: '83',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0.2,
      '45': 0.6,
      '46': 1.1,
      '47': 1.7,
      '48': 2.4,
      '49': 3.3,
      '50': 4.2,
      '51': 5.2,
      '52': 6.4,
      '53': 7.7,
      '54': 9,
      '55': 10.4,
      '56': 11.9,
      '57': 13.5,
      '58': 15.2,
      '59': 16.9,
      '60': 18.6,
      '61': 20.4,
      '62': 22.3,
      '63': 24.3,
      '64': 26.2,
      '65': 28.2,
      '66': 30.3,
      '67': 32.3,
      '68': 34.3,
      '69': 36.3,
      '70': 38.4,
      '71': 40.3,
      '72': 42.2,
      '73': 44.4,
      '74': 46.4,
      '75': 48.4,
      '76': 50.4,
      '77': 52.4,
      '78': 54.4,
      '79': 56.4,
      '80': 58.5,
      '81': 60.5,
      '82': 62.6,
      '83': 64.5,
      '84': 66.5,
      '85': 68.4,
      '86': 70.4,
      '87': 72.1,
      '88': 73.8,
      '89': 75.5,
      '90': 77,
      '91': 78.5,
      '92': 79.9,
      '93': 81.2,
      '94': 82.6,
      '95': 83.8,
      '96': 84.9,
      '97': 86.1,
      '98': 87,
      '99': 88.1,
      '100': 89.1,
      '101': 90,
      '102': 90.8,
      '103': 91.7,
      '104': 92.5,
      '105': 93.1,
      '106': 93.9,
      '107': 94.5,
      '108': 95.1,
      '109': 95.6,
      '110': 96.1,
      '111': 96.6,
      '112': 97.1,
      '113': 97.5,
      '114': 97.9,
      '115': 98.2,
      '116': 98.5,
      '117': 98.8,
      '118': 99.1,
      '119': 99.3,
      '120': 99.5,
      '121': 99.6,
      '122': 99.7,
      '123': 99.9,
      '124': 99.9,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '078(4E)',
    name: 'バズズ',
    HP: '250',
    MP: '50',
    Ex: '3350',
    G: '240',
    atk: '127',
    def: '170',
    speed: '75',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0.3,
      '41': 0.7,
      '42': 1.3,
      '43': 2,
      '44': 2.9,
      '45': 4,
      '46': 5.1,
      '47': 6.4,
      '48': 7.8,
      '49': 9.3,
      '50': 10.9,
      '51': 12.6,
      '52': 14.3,
      '53': 16.1,
      '54': 18,
      '55': 20.1,
      '56': 22.2,
      '57': 24.2,
      '58': 26.5,
      '59': 28.7,
      '60': 30.9,
      '61': 33.1,
      '62': 35.3,
      '63': 37.7,
      '64': 39.8,
      '65': 42.1,
      '66': 44.3,
      '67': 46.5,
      '68': 48.7,
      '69': 51,
      '70': 53.2,
      '71': 55.5,
      '72': 57.7,
      '73': 59.9,
      '74': 62.1,
      '75': 64.4,
      '76': 66.7,
      '77': 68.8,
      '78': 70.8,
      '79': 72.6,
      '80': 74.6,
      '81': 76.3,
      '82': 78,
      '83': 79.6,
      '84': 81.1,
      '85': 82.4,
      '86': 83.9,
      '87': 85.2,
      '88': 86.4,
      '89': 87.6,
      '90': 88.7,
      '91': 89.7,
      '92': 90.7,
      '93': 91.6,
      '94': 92.3,
      '95': 93.2,
      '96': 94,
      '97': 94.6,
      '98': 95.3,
      '99': 95.9,
      '100': 96.4,
      '101': 96.9,
      '102': 97.4,
      '103': 97.9,
      '104': 98.2,
      '105': 98.5,
      '106': 98.9,
      '107': 99.1,
      '108': 99.4,
      '109': 99.6,
      '110': 99.7,
      '111': 99.8,
      '112': 99.9,
      '113': 100,
      '114': 100,
      '115': 100,
      '116': 100,
      '117': 100,
      '118': 100,
      '119': 100,
      '120': 100,
      '121': 100,
      '122': 100,
      '123': 100,
      '124': 100,
      '125': 100,
      '126': 100,
      '127': 100,
      '128': 100,
      '129': 100,
      '130': 100,
      '131': 100,
      '132': 100,
      '133': 100,
      '134': 100,
      '135': 100,
      '136': 100,
      '137': 100,
      '138': 100,
      '139': 100,
      '140': 100,
      '141': 100,
      '142': 100,
      '143': 100,
      '144': 100,
      '145': 100,
      '146': 100,
      '147': 100,
      '148': 100,
      '149': 100
    }
  },
  {
    No: '079(4F)',
    name: 'ベリアル',
    HP: '320',
    MP: '240',
    Ex: '4750',
    G: '255',
    atk: '176',
    def: '180',
    speed: '120',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0.2,
      '64': 0.4,
      '65': 0.6,
      '66': 1,
      '67': 1.3,
      '68': 1.8,
      '69': 2.3,
      '70': 2.9,
      '71': 3.5,
      '72': 4.2,
      '73': 4.9,
      '74': 5.7,
      '75': 6.5,
      '76': 7.4,
      '77': 8.3,
      '78': 9.2,
      '79': 10.2,
      '80': 11.2,
      '81': 12.2,
      '82': 13.4,
      '83': 14.5,
      '84': 15.6,
      '85': 16.8,
      '86': 18,
      '87': 19.2,
      '88': 20.5,
      '89': 21.8,
      '90': 23.2,
      '91': 24.4,
      '92': 25.9,
      '93': 27.3,
      '94': 28.6,
      '95': 30,
      '96': 31.5,
      '97': 32.9,
      '98': 34.2,
      '99': 35.7,
      '100': 37,
      '101': 38.4,
      '102': 39.8,
      '103': 41.2,
      '104': 42.6,
      '105': 44,
      '106': 45.4,
      '107': 46.8,
      '108': 48.1,
      '109': 49.5,
      '110': 51,
      '111': 52.3,
      '112': 53.8,
      '113': 55.1,
      '114': 56.6,
      '115': 58,
      '116': 59.3,
      '117': 60.7,
      '118': 62.1,
      '119': 63.4,
      '120': 64.9,
      '121': 66.3,
      '122': 67.7,
      '123': 69,
      '124': 70.3,
      '125': 71.5,
      '126': 72.7,
      '127': 73.9,
      '128': 75.1,
      '129': 76.1,
      '130': 77.1,
      '131': 78.2,
      '132': 79.2,
      '133': 80.1,
      '134': 81.1,
      '135': 82,
      '136': 82.9,
      '137': 83.7,
      '138': 84.5,
      '139': 85.3,
      '140': 86,
      '141': 86.8,
      '142': 87.5,
      '143': 88.2,
      '144': 88.9,
      '145': 89.6,
      '146': 90.1,
      '147': 90.7,
      '148': 91.4,
      '149': 91.8
    }
  },
  {
    No: '080(50)',
    name: 'ハーゴン',
    HP: '460',
    MP: '255',
    Ex: '0',
    G: '0',
    atk: '177',
    def: '165',
    speed: '150',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0.1,
      '79': 0.2,
      '80': 0.4,
      '81': 0.6,
      '82': 0.8,
      '83': 1.1,
      '84': 1.5,
      '85': 1.9,
      '86': 2.2,
      '87': 2.7,
      '88': 3.2,
      '89': 3.7,
      '90': 4.3,
      '91': 4.8,
      '92': 5.4,
      '93': 6.1,
      '94': 6.7,
      '95': 7.4,
      '96': 8.2,
      '97': 8.9,
      '98': 9.7,
      '99': 10.5,
      '100': 11.2,
      '101': 12.1,
      '102': 13,
      '103': 13.9,
      '104': 14.8,
      '105': 15.8,
      '106': 16.7,
      '107': 17.6,
      '108': 18.7,
      '109': 19.7,
      '110': 20.6,
      '111': 21.7,
      '112': 22.7,
      '113': 23.8,
      '114': 24.9,
      '115': 26,
      '116': 27.2,
      '117': 28.2,
      '118': 29.3,
      '119': 30.5,
      '120': 31.6,
      '121': 32.7,
      '122': 33.9,
      '123': 35,
      '124': 36.1,
      '125': 37.2,
      '126': 38.3,
      '127': 39.5,
      '128': 40.5,
      '129': 41.6,
      '130': 42.6,
      '131': 43.8,
      '132': 45,
      '133': 46.1,
      '134': 47.2,
      '135': 48.4,
      '136': 49.5,
      '137': 50.6,
      '138': 51.6,
      '139': 52.8,
      '140': 53.9,
      '141': 55.1,
      '142': 56.2,
      '143': 57.3,
      '144': 58.3,
      '145': 59.6,
      '146': 60.6,
      '147': 61.7,
      '148': 62.8,
      '149': 63.9
    }
  },
  {
    No: '081(51)',
    name: 'シドー',
    HP: '1750',
    MP: '255',
    Ex: '0',
    G: '0',
    atk: '235',
    def: '240',
    speed: '110',
    speeds: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0.1,
      '58': 0.2,
      '59': 0.4,
      '60': 0.7,
      '61': 1.1,
      '62': 1.6,
      '63': 2.1,
      '64': 2.7,
      '65': 3.5,
      '66': 4.1,
      '67': 4.9,
      '68': 5.7,
      '69': 6.7,
      '70': 7.7,
      '71': 8.6,
      '72': 9.6,
      '73': 10.7,
      '74': 11.9,
      '75': 13,
      '76': 14.3,
      '77': 15.6,
      '78': 16.8,
      '79': 18.1,
      '80': 19.6,
      '81': 20.9,
      '82': 22.4,
      '83': 23.8,
      '84': 25.2,
      '85': 26.8,
      '86': 28.3,
      '87': 29.9,
      '88': 31.4,
      '89': 33,
      '90': 34.5,
      '91': 36,
      '92': 37.3,
      '93': 39,
      '94': 40.5,
      '95': 42,
      '96': 43.6,
      '97': 45,
      '98': 46.5,
      '99': 48.1,
      '100': 49.6,
      '101': 51.1,
      '102': 52.7,
      '103': 54.2,
      '104': 55.6,
      '105': 57.2,
      '106': 58.7,
      '107': 60.2,
      '108': 61.8,
      '109': 63.4,
      '110': 64.8,
      '111': 66.3,
      '112': 67.8,
      '113': 69.3,
      '114': 70.7,
      '115': 72,
      '116': 73.3,
      '117': 74.6,
      '118': 75.6,
      '119': 76.9,
      '120': 78,
      '121': 79.1,
      '122': 80.1,
      '123': 81.1,
      '124': 82.2,
      '125': 83.1,
      '126': 84.1,
      '127': 84.9,
      '128': 85.8,
      '129': 86.5,
      '130': 87.4,
      '131': 88.1,
      '132': 88.9,
      '133': 89.6,
      '134': 90.2,
      '135': 90.9,
      '136': 91.5,
      '137': 92.1,
      '138': 92.6,
      '139': 93.2,
      '140': 93.7,
      '141': 94.2,
      '142': 94.7,
      '143': 95.1,
      '144': 95.5,
      '145': 96,
      '146': 96.3,
      '147': 96.7,
      '148': 97,
      '149': 97.3
    }
  }
]
